import React, { createContext, useContext, useState } from "react";

const PlayerContext = createContext();

const defaultUsername = "You? Click on Connect!";
const defaultAvatarUUID = "6fc547ac-54d0-48b7-abe1-3f27981f9651";

export const PlayerProvider = ({ children }) => {
  const [username, setUsername] = useState(defaultUsername);
  const [uuid, setUUID] = useState(defaultAvatarUUID);

  const setUserUpdate = (newUsername, newUUID) => {
    setUsername(newUsername || defaultUsername);
    setUUID(newUUID || defaultAvatarUUID);
  };

  const setUserDefaultState = () => {
    setUsername(defaultUsername);
    setUUID(defaultAvatarUUID);
  };

  return (
    <PlayerContext.Provider
      value={{
        username,
        uuid,
        setUserUpdate,
        setUserDefaultState,
      }}
    >
      {children}
    </PlayerContext.Provider>
  );
};

export const usePlayer = () => useContext(PlayerContext);
